import { ValidationSummary } from 'devextreme-react/validation-summary';
import { Box, Item } from 'devextreme-react/box';
import Toolbar, { Item as ToolbarItem } from 'devextreme-react/toolbar';
import {
	WorksheetTemplateLink,
	CreateEstimateButton,
	ExitButton,
	RequestCancellationButton,
	RetailOrderAddNoteButton,
	RetailOrderFilesButton,
	RetailOrderInformationCards,
	RetailOrderNotesPanel,
	RetailOrderPage,
	RetailOrderProducts,
	RetailOrderProgress,
	RetailOrderProgressStep,
	SaveButton,
	SetToPendingButton,
	DeliveredToStoreDatesPanel,
	RetailOrderCommunicationButton,
	ChangeOrderButton,
	ViewChangeRequestButton
} from '../../../features/cfi/retail-order';
import '../../../css/order.scss';

export default function DeliveredToStoreDatePage() {

	return (
		<RetailOrderPage>

			<RetailOrderInformationCards />

			<RetailOrderProgress />

			<ValidationSummary />

			<Box>
				<Item ratio={1}>
					<Toolbar className='button-toolbar' multiline={true}>
						<ToolbarItem>
							<SaveButton step={RetailOrderProgressStep.DeliveredToStore} />
						</ToolbarItem>
						<ToolbarItem>
							<RetailOrderCommunicationButton />
						</ToolbarItem>
						<ToolbarItem>
							<RetailOrderFilesButton />
						</ToolbarItem>
						<ToolbarItem>
							<SetToPendingButton />
						</ToolbarItem>
						<ToolbarItem>
							<ChangeOrderButton step={RetailOrderProgressStep.POReceived} />
						</ToolbarItem>
						<ToolbarItem>
							<ViewChangeRequestButton step={RetailOrderProgressStep.POReceived} />
						</ToolbarItem>
						<ToolbarItem>
							<RequestCancellationButton />
						</ToolbarItem>
						<ToolbarItem>
							<ExitButton />
						</ToolbarItem>
					</Toolbar>
				</Item>
				<Item ratio={0} baseSize={190}>
					<Toolbar className='button-toolbar' multiline={true}>
						<ToolbarItem>
							<RetailOrderAddNoteButton showNoteType={false} changeOrder={false} />
						</ToolbarItem>
					</Toolbar>
				</Item>
			</Box>
			<Box>
				<Item ratio={1}>
					<DeliveredToStoreDatesPanel />
				</Item>
				<Item ratio={1}>
					<RetailOrderNotesPanel height={200} />
				</Item>
			</Box>

			<RetailOrderProducts />

		</RetailOrderPage>
	)
}
